module.exports = "/_next/static/images/profile-duotone-7fe2b9885befceb83e75c59e44352218.svg";